const DATE_TIME_LOCAL_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;

const pad = (value) => String(value).padStart(2, "0");

export const isDateTimeLocalValue = (value) =>
  typeof value === "string" && DATE_TIME_LOCAL_PATTERN.test(value);

export const getLocalDateTimeValue = (date = new Date()) => {
  const localDate = new Date(date);

  if (Number.isNaN(localDate.getTime())) {
    return "";
  }

  const year = localDate.getFullYear();
  const month = pad(localDate.getMonth() + 1);
  const day = pad(localDate.getDate());
  const hours = pad(localDate.getHours());
  const minutes = pad(localDate.getMinutes());

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const parseDateTimeLocalValue = (value) => {
  if (!value) return null;

  if (isDateTimeLocalValue(value)) {
    const [datePart, timePart] = value.split("T");
    const [year, month, day] = datePart.split("-").map(Number);
    const [hours, minutes] = timePart.split(":").map(Number);

    const localDate = new Date(year, month - 1, day, hours, minutes, 0, 0);
    return Number.isNaN(localDate.getTime()) ? null : localDate;
  }

  const parsedDate = new Date(value);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const toDateTimeLocalInputValue = (value) => {
  if (!value) return "";
  if (isDateTimeLocalValue(value)) return value;

  const parsedDate = parseDateTimeLocalValue(value);
  return parsedDate ? getLocalDateTimeValue(parsedDate) : "";
};